import { Component, NgZone, OnInit, ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ParamMap, Router, ActivatedRoute, Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { commonService } from "../../service/common.service";
import { helpdeskService } from "../../service/helpdesk.service";
import { Globals } from "../../globals";
import { Http, ResponseContentType } from '@angular/http';
import { FileSelectDirective, FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { ViewEncapsulation } from '@angular/core';

import {
  NgbModal, ModalDismissReasons, NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.css', '../../../../src/assets/scss/downloadprogress.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [helpdeskService]
})
export class HelpdeskComponent implements OnInit {
  modalReference: NgbModalRef;
  msgpopup = "";
  msgclass = "success";
  isSuccess = false;
  start = 0;
  end = 10;
  closeResult: string;
  limit = 20;

  contentlist = [];
  isPostLoad = true;
  isRemaningForum = true;
  noMoreResults = false;

  isError = false;
  msg: any;
  datanotfound = false;
  catlistshow: any;
  usercomment = "";
  filepath: any;
  isclickbuttonRegisterhelpdesk = false;
  formvailidation = false;


  uploaderror: any = "";
  uploadimageName: any;
  ckeConfig: any;

  helpattachmentarry: any = [];
  percentDone = 0;
  activeCurrentDwnld = [];
  progress:any;

  attachmentUrl = this.global.siteUrl + 'file/upload?folder=' + this.global.profileFolder + '&mediaFor=helpdesk';

  uploader: FileUploader = new FileUploader({ url: this.attachmentUrl, authToken: sessionStorage.getItem('_to') });


  constructor(private httpp: Http, private http: HttpClient, private modalService: NgbModal, private global: Globals, private _common: commonService, private _helpdesk: helpdeskService, private router: Router, private route: ActivatedRoute) {


    this.filepath = this.global.profileUrl;
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.contentlist = [];
        this.getticketlist();

      }
      else {
        this.getticketlist();
      }
    })


    this.ckeConfig = {
      height: 100,
      language: "en",
      image_previewText: '',
      allowedContent: true,
      extraPlugins: 'uploadimage',

      mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
      // allowedContent: true,
      // extraPlugins: "divarea",
      toolbar: [
        // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
        // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
        { name: "links", items: ["Link"] },
        //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
        // { name: "document", items: ["Source"] },
        //{ name: "insert", items: ["Image", "customImageupload", "Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
        //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
        // For New Line  "/",
        //{ name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
        //{ name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
        // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
      ],
      filebrowserUploadUrl: this.global.objectStorage + 'ckeditor/upload'
    };

  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    var scrollPosition = $(window).scrollTop() + $(window).height();
    var pageheight = $(document).height() - $('#footer-section').outerHeight();

    //var pageheight =  $(document).height()-100;
    if (scrollPosition >= pageheight && this.isRemaningForum == true && this.contentlist.length > 0) {
      this.isPostLoad = true;

      this.getticketlist();

    }
  }


  getticketlist() {
    let formdata: any = {};
    formdata.offset = this.contentlist.length ? this.contentlist.length : 0;
    formdata.limit = this.limit;
    formdata.userId = this._common.user.id;
    this._helpdesk.gethelpticketlist(formdata).subscribe((data: any) => {

      if (data.error == 0) {
        //console.log('ticket list ' + data.results.count + 'pppppppp' + formdata.offset);
        if (data.results.count > 0 && formdata.offset < data.results.count) {

          this.datanotfound = false;
          this.isPostLoad = false;
          Array.prototype.push.apply(this.contentlist, data.results.rows);

        }
        else {
          this.isRemaningForum = false;
          this.isPostLoad = false;
          this.noMoreResults = true;
          this.datanotfound = true;
          //this.msg = 'Data Not Found';

        }

      }
      else {
        this.datanotfound = true;
        this.msg = data.message;
      }

    }, (error: HttpErrorResponse) => {
      this.isError = true;
      this.msg = "internal server error!";
    });
  }



  openviewticket(content) {
    //console.log('gggg');

    this.msgpopup = "";
    this.modalReference = this.modalService.open(content, { size: 'lg' });
  }

  helpcommentsubmit(helpcommentform, obj) {
    this.isclickbuttonRegisterhelpdesk = true;
    helpcommentform.value.userId = this._common.user.id;
    let ticketdata = {};
    let commentdata = {};
    ticketdata['ticketId'] = helpcommentform.value.ticketId;
    ticketdata['status'] = helpcommentform.value.status;
    ticketdata['supportType'] = helpcommentform.value.supportType;

    commentdata['ticketId'] = helpcommentform.value.ticketId;
    commentdata['comment'] = helpcommentform.value.comment;

    this._helpdesk.updatehelpdeskticket(ticketdata).subscribe((data: any) => {
      if (data.error == 0) {
        this.isclickbuttonRegisterhelpdesk = false;
        this.getticketlist();
        if (helpcommentform.value.comment != '' || this.helpattachmentarry.length > 0) {
          /***comment service* */
          if (this.helpattachmentarry.length > 0) {
            helpcommentform.value.mediaId = this.helpattachmentarry;
          } else { helpcommentform.value.mediaId = []; }

          this._helpdesk.addhelpcomment(helpcommentform.value).subscribe((data: any) => {
            if (data.error == 0) {
              this.msgpopup = "updated successfully";
              this.msgclass = "success";
              this.usercomment = "";
              obj.ticketComments.push({ comment: helpcommentform.value.comment, id: data.results, userId: this._common.user.id, ticketId: helpcommentform.value.ticketId, ticketCommentMedia: [] });
              obj = obj;
              if (this.helpattachmentarry.length > 0) {
                for (var tt in obj.ticketComments) {
                  if (data.results == obj.ticketComments[tt].id) {
                    for (var i in data.mediarry) {
                      obj.ticketComments[tt].ticketCommentMedia.push({ id: data.mediarry[i].id, commentId: data.results, uploadname: data.mediarry[i].uploadname });

                    }

                  }

                }

              }
              this.uploader.queue = [];
              this.helpattachmentarry = [];
            }
          },
            (error: HttpErrorResponse) => {
              this.isError = true;
              this.msg = "internal server error!";
            });
        }
        else {
          this.msgpopup = "updated successfully";
          //this.msg = this.profileData.imagetype + " Image has been changed successfully";
          this.msgclass = "success";
          this.sleep(1000).then(() => {
            this.modalReference.close('Cross click');
          })
        }
        /***comment service* */

      }

    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });



  }
  deletecomment(Id, objarry) {
    if (window.confirm('Are you sure you want to delete this Comment ?')) {
      this._helpdesk.deletecomment(Id).subscribe((data: any) => {
        if (data.error == 0) {

          for (let objid of objarry.ticketComments) {
            if (objid.id == Id) {
              objarry.ticketComments.splice(objarry.ticketComments.indexOf(objid), 1);
              break;
            }
          }
          // this.isSuccess = true;
          // this.msg = "Category has been deleted successfully!";
          // this.getcatlist()
        } else {
          this.isError = true;
          this.msg = data.error;
        }
      },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        });
    }

  }
  delticket(Id) {
    if (window.confirm('Are you sure you want to delete this Ticket ?')) {
      this._helpdesk.deleteticket(Id).subscribe((data: any) => {
        if (data.error == 0) {
          this.isSuccess = true;
          this.msg = "Ticket has been deleted successfully!";
          for (let cont of this.contentlist) {
            if (cont.id == Id) {
              this.contentlist.splice(this.contentlist.indexOf(cont), 1);
              break;
            }
          }
        } else {
          this.isError = true;
          this.msg = data.error;
        }
      },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        });
    }
  }
  //deleteattachment

  deleteattachment(Id, objarry) {
    if (window.confirm('Are you sure you want to delete this File ?')) {
      this._helpdesk.deleteattachment(Id).subscribe((data: any) => {
        if (data.error == 0) {

          for (let objid of objarry.ticketmedia) {
            if (objid.id == Id) {
              objarry.ticketmedia.splice(objarry.ticketmedia.indexOf(objid), 1);
              break;
            }
          }
          // this.isSuccess = true;
          // this.msg = "Category has been deleted successfully!";
          // this.getcatlist()
        } else {
          this.isError = true;
          this.msg = data.error;
        }
      },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        });
    }

  }



  public downloadFile(filename) {
    var downloadurl = this.filepath + filename;


    this.percentDone = 0;
    this.activeCurrentDwnld[filename] = true;
    const req = new HttpRequest('GET', downloadurl, {
      reportProgress: true,
      responseType: 'blob'
    });

    this.http.request(req).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          console.log('Request sent!');
          break;
        case HttpEventType.ResponseHeader:
          console.log('Response header received!');
          break;
        case HttpEventType.DownloadProgress:
          this.percentDone = Math.round(100 * event.loaded / event.total);
          console.log(this.percentDone);
          break;
        case HttpEventType.Response:
          console.log('Done!', event);
          let file = event.body;
          console.log(file.size + " bytes file downloaded. File type: ", file.type);
          // create and download link
          var url = window.URL.createObjectURL(file);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element */

      }

    }, error => {
      if (error.status = "404") {
        alert('Something went wrong. Please try to latter.');
        this.percentDone = 0;
        this.activeCurrentDwnld[filename] = false;
      }
    }, () => {
      this.percentDone = 0;
      this.activeCurrentDwnld[filename] = false;
    });
  }

  /******************************* Image Upload *****************/
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });
  }

  getTPpdf(imagename) {
    return this.global.testseriesImageUrl + imagename;

  }

  onFileHelpComeentChanged(event) {
    this.helpattachmentarry = [];
    this.uploader.uploadAll();
    this.progress=1;


  }

  clearallque() {
    console.log('click upload');
    this.uploader.queue = [];
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    console.log("Success");
    //console.log(item); 
    this.progress=0;
    let data = JSON.parse(response); //success server response
    console.log(data.result);
    this.helpattachmentarry.push(data.result.id);



  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response

    console.log(error);
  }
  private sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  /**************** End of Image Upload *****************/

  deletecommentmedia(Id, objarry) {
    console.log('media comment delete', objarry);
    //return false;
    if (window.confirm('Are you sure you want to delete this comment File ?')) {
      this._helpdesk.deletecommentmedia(Id).subscribe((data: any) => {
        if (data.error == 0) {

          for (let objid of objarry) {
            if (objid.id == Id) {
              objarry.splice(objarry.indexOf(objid), 1);
              break;
            }
          }
        } else {
          this.isError = true;
          this.msg = data.error;
        }
      },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        });
    }

  }

  openhelpdeshpopup(data) {
    data.action = true;
    this._common.setHelpdeskBox(data);
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/helpdesk/helpdesk.component.ts